import { useState, useEffect, useCallback } from 'react';
import abTestingManager from '../utils/abTesting';

/**
 * Hook para usar A/B Testing en componentes React
 */
export const useABTest = (testName, options = {}) => {
    const { forceVariant, trackExposure = true } = options;

    const [variant, setVariant] = useState(null);
    const [config, setConfig] = useState({});
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        try {
            const selectedVariant = abTestingManager.getVariant(testName, forceVariant);
            const variantConfig = abTestingManager.getVariantConfig(testName, selectedVariant);

            setVariant(selectedVariant);
            setConfig(variantConfig);
            setIsLoading(false);

            if (trackExposure) {
                abTestingManager.trackVariantExposure(testName, selectedVariant);
            }
        } catch (error) {
            console.error('Error in A/B test hook:', error);
            setVariant('control');
            setConfig(abTestingManager.getVariantConfig(testName, 'control'));
            setIsLoading(false);
        }
    }, [testName, forceVariant, trackExposure]);

    // Función para trackear eventos
    const trackEvent = useCallback((eventName, additionalData = {}) => {
        abTestingManager.trackEvent(eventName, testName, additionalData);
    }, [testName]);

    // Función para trackear conversión
    const trackConversion = useCallback((additionalData = {}) => {
        abTestingManager.trackConversion(testName, additionalData);
    }, [testName]);

    // Función para trackear paso completado
    const trackStepComplete = useCallback((step, additionalData = {}) => {
        abTestingManager.trackStepComplete(testName, step, additionalData);
    }, [testName]);

    return {
        variant,
        config,
        isLoading,
        trackEvent,
        trackConversion,
        trackStepComplete
    };
};

export const useFormOptimization = (options = {}) => {
    return useABTest('form_optimization', options);
};

export const useHeroMessageTest = (options = {}) => {
    return useABTest('hero_message', options);
};

export const useABTestStatus = () => {
    const [status, setStatus] = useState({});
    const [isDevelopment, setIsDevelopment] = useState(false);

    useEffect(() => {
        setIsDevelopment(process.env.NODE_ENV === 'development');
        setStatus(abTestingManager.getTestStatus());
    }, []);

    return {
        status,
        isDevelopment
    };
};
